import { inject, observer } from 'mobx-react';
import AgGrid from '../../../common/components/ag-grid/ag-grid';
import { AppConstants } from '../../../common/APIConstants';
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CheckboxRenderer from '../../../common/CheckboxRenderer';
import SmartSelectClearable from '../../../common/SmartSelectClearable';

@inject('NGLTeamDailyReportStore')
@observer
class NGLTeamDailyReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gridOptions: {
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: 'always',
        suppressContextMenu: true,
        statusBar: {
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left'
            },
            {
              statusPanel: 'agAggregationComponent',
              statusPanelParams: {
                aggFuncs: ['avg', 'count', 'min', 'max', 'sum']
              }
            }
          ]
        },
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel'
            }
          ],
          showToolPanel: false
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true
        },
        frameworkComponents: {
          SmartSelectClearable: SmartSelectClearable,
          booleanCellEditor: CheckboxRenderer
        }
      },
      towerKPIGridOptions: {
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: 'always',
        suppressContextMenu: true,
        statusBar: {
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left'
            },
            {
              statusPanel: 'agAggregationComponent',
              statusPanelParams: {
                aggFuncs: ['avg', 'count', 'min', 'max', 'sum']
              }
            }
          ]
        },
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel'
            }
          ],
          showToolPanel: false
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true
        },
        autoGroupColumnDef: {
          minWidth: 209
        }
      },
      towerKPIGridColState:
        [
          {
            "colId": "ag-Grid-AutoColumn",
            "hide": false,
            "aggFunc": null,
            "width": 230,
            "pivotIndex": null,
            "pinned": null,
            "rowGroupIndex": null
          },
          {
            "colId": "TowerKPIID",
            "hide": true,
            "aggFunc": null,
            "width": 200,
            "pivotIndex": null,
            "pinned": null,
            "rowGroupIndex": null
          },
          {
            "colId": "DailyReportInfoID",
            "hide": true,
            "aggFunc": null,
            "width": 200,
            "pivotIndex": null,
            "pinned": null,
            "rowGroupIndex": null
          },
          {
            "colId": "Group",
            "hide": false,
            "aggFunc": null,
            "width": 200,
            "pivotIndex": 0,
            "pinned": null,
            "rowGroupIndex": null
          },
          {
            "colId": "Identifier",
            "hide": false,
            "aggFunc": null,
            "width": 468,
            "pivotIndex": 1,
            "pinned": null,
            "rowGroupIndex": null
          },
          {
            "colId": "Parameter",
            "hide": false,
            "aggFunc": null,
            "width": 564,
            "pivotIndex": null,
            "pinned": null,
            "rowGroupIndex": 0
          },
          {
            "colId": "InstantValue",
            "hide": false,
            "aggFunc": "sum",
            "width": 580,
            "pivotIndex": null,
            "pinned": null,
            "rowGroupIndex": null
          }
        ]
    };
  }

  render() {
    const { screenRowData, screenColumnDefinitions, headerDetails } = this.props.NGLTeamDailyReportStore;
    const parentScreen = this.getCurrentScreenParent();
    return (
      <div className="col-md-12">
        <div className="container cb-title-container">
          <h3 className="cb-title">{parentScreen.screen.title}</h3>
        </div>
        <div className="col-md-12">
          <div className="row nglteam-header-row justify-content-center sticky-top rounded">
            <div className="col-md-2">
              <label className="nglteam-header-row-label">Start Date:</label><br />
              {this.props.NGLTeamDailyReportStore.hasScreenData && <label>{headerDetails.startDateTime}</label>}
            </div>
            <div className="col-md-2">
              <label className="nglteam-header-row-label">End Date:</label><br />
              <DatePicker
                selected={moment(headerDetails.endDateTime).toDate()}
                dateFormat={"MM/dd/yyyy 07:00"}
                onChange={async (date) => { await this.onEndDateChange(date) }}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onChangeRaw={(e) => { e.preventDefault(); }}
              />
            </div>
            <div className="col-md-2">
              <label className="nglteam-header-row-label">Current Date:</label><br />
              {this.props.NGLTeamDailyReportStore.hasScreenData && <label>{headerDetails.currentDateTime}</label>}
            </div>
            <div className="col-md-2">
              <label className="nglteam-header-row-label">Max Ambient Temp:</label><br />
              {this.props.NGLTeamDailyReportStore.hasScreenData && <label>{headerDetails.maxAmbientTemp}</label>}
            </div>
            <div className="col-md-2">
              <label className="nglteam-header-row-label">Min Ambient Temp:</label><br />
              {this.props.NGLTeamDailyReportStore.hasScreenData && <label>{headerDetails.minAmbientTemp}</label>}
            </div>
            <div className="col-md-2">
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                onClick={this.saveScreenData}
                style={{ width: '100%', margin: '10px' }}
                disabled={!this.props.NGLTeamDailyReportStore.hasScreenData || this.props.NGLTeamDailyReportStore.getIsDataReadOnly()}
              >
                {"Save Data"}
              </button>
            </div>
          </div>
          {this.props.NGLTeamDailyReportStore.hasScreenData && <>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group" style={{ padding: '10px' }}>
                  <div className="col-md-12">
                    <label className="nglteam-textarea-label" for="SafetyMoment">Safety Moment:</label>
                    <textarea
                      value={this.props.NGLTeamDailyReportStore.safetyMoment}
                      maxLength="8000"
                      className="form-control"
                      id="SafetyMoment"
                      rows="5"
                      onInput={(event) => {
                        this.props.NGLTeamDailyReportStore.safetyMoment = event.target.value;
                      }}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="nglteam-textarea-label" for="ActionItemReview">Operation Notes:</label>
                    <textarea
                      value={this.props.NGLTeamDailyReportStore.actionItemReview}
                      maxLength="8000"
                      className="form-control"
                      id="ActionItemReview"
                      rows="5"
                      onInput={(event) => {
                        this.props.NGLTeamDailyReportStore.actionItemReview = event.target.value;
                      }}
                      placeholder={"Please add meeting notes here"}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>PINS/HAZIDs</label>
                </div>
              </div>
              <AgGrid
                gridID={"Incident"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.Incident}
                rowData={screenRowData.Incident}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>Production</label>
                </div>
              </div>
              <AgGrid
                gridID={"Production"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.Production}
                rowData={screenRowData.Production}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>Previous Day Re-Run</label>
                </div>
              </div>
              <AgGrid
                gridID={"PreviousDayReRun"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.PreviousDayReRun}
                rowData={screenRowData.PreviousDayReRun}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>C2 Blending</label>
                </div>
              </div>
              <AgGrid
                gridID={"C2Blending"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.C2Blending}
                rowData={screenRowData.C2Blending}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>C3 Blending</label>
                </div>
              </div>
              <AgGrid
                gridID={"C3Blending"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.C3Blending}
                rowData={screenRowData.C3Blending}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>Product Spec</label>
                </div>
              </div>
              <AgGrid
                gridID={"ProductSpec"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.ProductSpec}
                rowData={screenRowData.ProductSpec}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>Flare Gas Compressor</label>
                </div>
              </div>
              <AgGrid
                gridID={"FlareGasCompressorInfo"}
                gridOptions={this.state.gridOptions}
                columnDefs={screenColumnDefinitions.FlareGasCompressorInfo}
                rowData={screenRowData.FlareGasCompressorInfo}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
            <div className="row">
              <div className="col-md-12 cb-title-container nglteam-grid-title">
                <div className="col-md-12">
                  <label>Tower KPIs (Current Time)</label>
                  <a
                    style={{ fontSize: '16px', float: 'right', paddingRight: 'inherit' }}
                    href="https://pi_cal_web/PIVision/#/Displays/10617/Sarnia_Fract_KPI?mode=kiosk"
                    target="_blank"
                    rel="noopener noreferrer">
                    <u>PI Vision Report</u>
                  </a>
                </div>
              </div>
              <AgGrid
                gridID={"TowerKPI"}
                gridOptions={this.state.towerKPIGridOptions}
                columnDefs={screenColumnDefinitions.TowerKPI}
                rowData={screenRowData.TowerKPI}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
            </div>
          </>}
        </div>
      </div>
    );
  }

  componentDidMount = async () => {
    await this.refreshData();
  };

  getCurrentScreenParent = () => {
    const parentScreenName = this.props.path.split('/').pop();
    const parentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === parentScreenName
    );

    return parentScreen;
  };

  getCurrentScreenChildren = () => {
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName
    );

    return currentScreenChildren;
  };

  onEndDateChange = async (date) => {
    const { NGLTeamDailyReportStore } = this.props;
    NGLTeamDailyReportStore.headerDetails.endDateTime = moment(date).format("MM/DD/YYYY");
    await this.refreshData();
  };

  refreshData = async () => {
    await this.getScreenData();
  };

  getScreenData = async () => {
    const { CommonStore, NGLTeamDailyReportStore } = this.props;
    const currentScreenChildren = this.getCurrentScreenChildren();
    await NGLTeamDailyReportStore.getScreenData(currentScreenChildren, CommonStore);

    if (this.props.NGLTeamDailyReportStore.hasScreenData) {
      this.state.towerKPIGridOptions.columnApi.setColumnState(this.state.towerKPIGridColState);
      this.state.towerKPIGridOptions.columnApi.setPivotMode(true);
      this.state.towerKPIGridOptions.columnApi.autoSizeAllColumns();
    }
  };

  saveScreenData = async () => {
    // console.log("col state", JSON.stringify(this.state.towerKPIGridOptions.columnApi.getColumnState()))
    const { CommonStore, NGLTeamDailyReportStore } = this.props;
    const currentScreenChildren = this.getCurrentScreenChildren();
    await NGLTeamDailyReportStore.saveScreenData(currentScreenChildren, CommonStore);
    await this.refreshData();
  };

  onCellValueChanged = (e) => {
    if (e.newValue !== null && e.oldValue != e.newValue) {
      this.state.gridOptions.api.refreshCells();
    }
    else {
      e.node.setDataValue(e.colDef.field, e.oldValue);
      this.state.gridOptions.api.refreshCells();
    }
  };
}

export default NGLTeamDailyReport;